module.exports = __webpack_public_path__ + "kidsMobile.png";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/pages/newLandingPage/ui/preview-popup/assets/kidsMobile.png
// module id = 1182
// module chunks = 10